module.exports = __webpack_public_path__ + "static/blog-01-c54eadfd7a9eb538827f405ef39d023c.jpg";